import Box from '@mui/material/Box';
import { BRAND } from '@/constants/assets';
import { MONO_FONT, SERIF_FONT } from '@/theme';
import { company } from '@/libs/company';

/**
 * Marca del estudio: isotipo + wordmark en dos líneas ("GÓMEZ & THOMAS" /
 * "ABOGADOS"). El wrapper (Link) lo pone el consumidor.
 *
 * @param {boolean} dark      true → isotipo dorado + texto claro (sobre navy)
 * @param {boolean} showText  oculta el wordmark en < sm cuando es false-forzado por CSS del consumidor
 */
export default function Logo({ dark = true, height = 44, showText = true }) {
  const markSrc = dark ? BRAND.markGold : BRAND.markNavy;
  const wordColor = dark ? '#f3ede1' : '#1b2a44';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
      <Box
        component="img"
        src={markSrc}
        alt={`Logo de ${company.name}`}
        sx={{ height, width: 'auto', display: 'block' }}
      />
      {showText && (
        <Box
          sx={{
            display: { xs: 'none', sm: 'flex' },
            flexDirection: 'column',
            lineHeight: 1,
          }}
        >
          <Box
            component="span"
            sx={{
              fontFamily: SERIF_FONT,
              fontSize: '20px',
              fontWeight: 600,
              letterSpacing: '0.14em',
              color: wordColor,
            }}
          >
            GÓMEZ &amp; THOMAS
          </Box>
          <Box
            component="span"
            sx={{
              fontFamily: MONO_FONT,
              fontSize: '10px',
              fontWeight: 600,
              letterSpacing: '0.42em',
              color: 'primary.main',
              mt: '5px',
            }}
          >
            ABOGADOS
          </Box>
        </Box>
      )}
    </Box>
  );
}
